import { render } from "./TheTabs.vue?vue&type=template&id=3f99fce0&scoped=true"
import script from "./TheTabs.vue?vue&type=script&lang=js"
export * from "./TheTabs.vue?vue&type=script&lang=js"

import "./TheTabs.vue?vue&type=style&index=0&id=3f99fce0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f99fce0"]])

export default __exports__